// Constrain a post-auth `redirect` query param to a same-app relative path.
// react-router keeps navigation same-origin, but we still reject values that
// don't start with a single "/" (e.g. "//evil.com" protocol-relative URLs, or
// absolute "http://…") so a crafted link can't bounce the user off-app.
export function safeRedirect(path, fallback = '/dashboard') {
    if (typeof path !== 'string') return fallback;
    if (!path.startsWith('/') || path.startsWith('//')) return fallback;
    return path;
}

// Paths that must render for a signed-OUT visitor.
//
// These are the pages someone can legitimately be on without a session: the public
// landing page, the legal pages App Store Connect points at, the auth screens
// themselves, and an emailed invite link. `/invite/:token` is matched by prefix
// because the token varies.
const PUBLIC_PATHS = ['/', '/login', '/register', '/privacy', '/support', '/forgot-password', '/reset-password'];
const PUBLIC_PREFIXES = ['/invite/'];

export function isPublicPath(pathname) {
    if (typeof pathname !== 'string') return false;

    // Tolerate a trailing slash so "/privacy/" behaves like "/privacy".
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;

    return PUBLIC_PATHS.includes(path) || PUBLIC_PREFIXES.some((p) => pathname.startsWith(p));
}
